import { useEffect, useState } from 'react';

export const DEFAULT_COUNTDOWN_MS = 2000;

export default function useCountdown(durationMs = DEFAULT_COUNTDOWN_MS) {
  const [endsAt] = useState(() => Date.now() + durationMs);
  const [remainingMs, setRemainingMs] = useState(() => Math.max(0, durationMs));

  useEffect(() => {
    if (endsAt <= Date.now()) return;
    let timer: ReturnType<typeof setTimeout>;
    const updateRemaining = () => {
      const remaining = Math.max(0, endsAt - Date.now());
      setRemainingMs(remaining);
      if (remaining > 0) {
        timer = setTimeout(updateRemaining, Math.min(1000, remaining));
      }
    };
    timer = setTimeout(updateRemaining, Math.min(1000, endsAt - Date.now()));
    return () => clearTimeout(timer);
  }, [endsAt]);

  return {
    remainingMs,
    hasElapsed: () => Date.now() >= endsAt,
  };
}
